import styled from "styled-components";

export const Container = styled.div`
  max-width: 400px;
  margin: 0 auto;
  padding: 2rem;
`;

export const HeadingContainer = styled.div`
  margin-bottom: 2rem;
  text-align: center;
`;

export const Heading = styled.h1`
  font-size: 1.5rem;
  margin-bottom: 0.5rem;
  color: #333;
`;

export const Subheading = styled.p`
  color: #666;
  font-size: 0.9rem;
  line-height: 1.5;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const DateInputLabel = styled.label`
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  color: #333;
  font-size: 0.95rem;
`;

export const DateInput = styled.input`
  width: 100%;
  padding: 0.75rem;
  font-size: 1rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  transition: border-color 0.2s;
  box-sizing: border-box;

  &:focus {
    outline: none;
    border-color: #1976d2;
    box-shadow: 0 0 0 2px rgba(25, 118, 210, 0.1);
  }

  &:disabled {
    background-color: #f5f5f5;
    cursor: not-allowed;
  }

  &::placeholder {
    color: #999;
  }
`;

export const DateInputHint = styled.div`
  margin-top: 0.25rem;
  font-size: 0.85rem;
  color: #666;
`;

export const ErrorMessage = styled.div`
  color: #d32f2f;
  background-color: #ffebee;
  padding: 0.75rem;
  border-radius: 4px;
  font-size: 0.9rem;
  border-left: 3px solid #d32f2f;
`;

export const SubmitButton = styled.button`
  padding: 0.875rem;
  font-size: 1rem;
  font-weight: 500;
  color: white;
  background-color: #1976d2;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover:not(:disabled) {
    background-color: #1565c0;
  }

  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.3);
  }
`;

export const InfoMessage = styled.div`
  display: flex;
  gap: 1rem;
  padding: 1.5rem;
  background-color: #e3f2fd;
  border-left: 4px solid #1976d2;
  border-radius: 4px;
  margin-bottom: 1.5rem;
`;

export const InfoIcon = styled.div`
  font-size: 2rem;
  line-height: 1;
  flex-shrink: 0;
`;

export const InfoText = styled.div`
  flex: 1;
`;

export const InfoTitle = styled.h3`
  margin: 0 0 0.5rem 0;
  font-size: 1.1rem;
  font-weight: 600;
  color: #1565c0;
`;

export const InfoDescription = styled.p`
  margin: 0 0 0.75rem 0;
  color: #555;
  line-height: 1.5;
  font-size: 0.95rem;
`;

export const InfoInstructions = styled.p`
  margin: 0;
  color: #333;
  font-weight: 500;
  font-size: 0.95rem;
`;

export const BackButton = styled.button`
  padding: 0.875rem;
  font-size: 1rem;
  font-weight: 500;
  color: #1976d2;
  background-color: white;
  border: 2px solid #1976d2;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s;
  width: 100%;

  &:hover {
    background-color: #e3f2fd;
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.3);
  }
`;
